var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 350,
    viewBox: "0 0 400 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.01 50.3047C196 46.8507 203.333 46.7422 209.407 49.9805L209.99 50.3047L329.99 119.499C336.184 123.07 340 129.676 340 136.825V286C340 297.046 331.046 306 320 306H80C68.9543 306 60 297.046 60 286V136.825C60 129.899 63.5811 123.484 69.4355 119.843L70.0098 119.499L190.01 50.3047Z",
    stroke: "#EA3377",
    strokeWidth: 20
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113 169.5L263 169.5",
    stroke: "#FF3131",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113 252.5H182",
    stroke: "#68ADE5",
    strokeWidth: 25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113 210.5L243 210.5",
    stroke: "#93E54B",
    strokeWidth: 25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.426a76203758349eb45f276f73f033ae.svg";
export { ForwardRef as ReactComponent };